import { render, staticRenderFns } from "./CustomerStatistics.vue?vue&type=template&id=1b0381a1&scoped=true"
import script from "./CustomerStatistics.vue?vue&type=script&lang=js"
export * from "./CustomerStatistics.vue?vue&type=script&lang=js"
import style0 from "./CustomerStatistics.vue?vue&type=style&index=0&id=1b0381a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0381a1",
  null
  
)

export default component.exports